/**
 * Shared temperature badge styles (HOT / WARM / COLD).
 * Single mapping for premium look: stronger border, subtle glow, good contrast.
 * Dark-mode friendly.
 */

export type TemperatureValue = 'hot' | 'warm' | 'cold' | 'stale';

export const TEMP_STYLES: Record<TemperatureValue, string> = {
  hot:
    'bg-red-500/18 text-red-700 dark:text-red-300 border border-red-500/60 shadow-[0_0_16px_rgba(239,68,68,0.18)] dark:shadow-[0_0_16px_rgba(248,113,113,0.18)] font-medium',
  warm:
    'bg-amber-500/18 text-amber-800 dark:text-amber-300 border border-amber-500/60 shadow-[0_0_16px_rgba(245,158,11,0.18)] dark:shadow-[0_0_16px_rgba(251,191,36,0.18)] font-medium',
  cold:
    'bg-sky-500/18 text-sky-700 dark:text-sky-300 border border-sky-500/60 shadow-[0_0_16px_rgba(14,165,233,0.18)] dark:shadow-[0_0_16px_rgba(56,189,248,0.18)] font-medium',
  stale:
    'bg-zinc-500/10 text-zinc-600 dark:text-zinc-400 border border-zinc-500/30 font-medium',
};

export const TEMP_BASE_CLASSES =
  'inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] tracking-wide backdrop-blur-sm';
